const my_profile = {
  viewMyClubSeacretProfile: "Xem hồ sơ ClubSeacret của tôi", // translated 
  viewMoreDetails: "Xem thêm chi tiết", // translated 
  verifiedEmail: "Email đã được xác minh", // translated 
  unverifiedEmail: "Email chưa được xác minh", // translated 
  balance: "Sự cân bằng", // translated 
  pointsIn: "Điểm trong", // translated 
  pointsOut: "Chỉ ra", // translated 
  topUp: "Nạp tiền", // translated 
  pointsHistoryTable: "Bảng lịch sử điểm", // translated 
  createdFrom: "Được tạo từ", // translated 
  createdTo: "Được tạo ra để", // translated 
  selectStatus: "Chọn trạng thái...", // translated 
  searchByTitle: "Tìm kiếm theo tiêu đề...", // translated 
  offerStatus: "Trạng thái ưu đãi", // translated 
  selectOfferStatus: "Tất cả", // translated 
  quotationSent: "Báo giá đã được gửi", // translated 
  offerInProgress: "Đang trong quá trình chào bán", // translated 
  offerAvailable: "Ưu đãi có sẵn", // translated 
  offerAccepted: "Đã chấp nhận đề nghị", // translated 
  offerExpired: "Ưu đãi đã hết hạn", // translated 
  offerReference: "Mã số tham chiếu chào hàng", // translated 
  tripStartDate: "Ngày bắt đầu chuyến đi", // translated 
  dueDate: "Ngày đến hạn", // translated 
  viewOffer: "Xem ưu đãi", // translated 
  notApplicable: "Không áp dụng", // translated 
  manageSubscription: "Quản lý đăng ký", // translated 
  logoAndColors: "Logo & Màu sắc", // translated 
  editColors: "Chỉnh sửa màu sắc", // translated 
  editLogo: "Chỉnh sửa logo", // translated 
  primaryColor: "Màu cơ bản", // translated 
  secondaryColor: "Màu thứ cấp", // translated 
  subagentLogoAlt: "Logo đại lý phụ", // translated 
  pickColors: "Chọn màu sắc", // translated 
  logoPreview: "Xem trước logo", // translated 
  logoPreviewAlt: "Xem trước logo", // translated 
  noLogoSelected: "Chưa chọn logo nào", // translated 
  changeLogo: "Thay đổi logo", // translated 
  uploadLogo: "Tải lên logo", // translated 
  supportedImageFormats: "Các định dạng được hỗ trợ: JPG, PNG. Kích thước tối đa: 2MB", // translated 
  saving: "Đang lưu...", // translated 
  logoUpdatedSuccess: "Logo đã được cập nhật thành công.", // translated 
  failedToUpdateLogo: "Không thể cập nhật logo", // translated 
  colorsUpdatedSuccess: "Màu sắc đã được cập nhật thành công", // translated 
  failedToUpdateColors: "Không thể cập nhật màu sắc", // translated 
  selectImageFile: "Vui lòng chọn một tệp hình ảnh.", // translated 
  imageSizeLimit: "Kích thước ảnh phải nhỏ hơn 5MB.", // translated 
  pushNotifications: "Thông báo đẩy", // translated 
  pushNotificationsDescription: "Nhận thông báo trên trình duyệt về các bản cập nhật và sự kiện quan trọng.", // translated 
  pushNotificationsNotSupported: "Trình duyệt này không hỗ trợ thông báo đẩy.", // translated 
  pushNotificationsDeniedMessage: "Quyền nhận thông báo đã bị từ chối. Vui lòng bật thông báo trong cài đặt trình duyệt của bạn để nhận thông báo đẩy.", // translated 
  pushNotificationsEnabled: "Thông báo đẩy đã được bật thành công", // translated 
  pushNotificationsDisabled: "Thông báo đẩy đã bị vô hiệu hóa thành công.", // translated 
  userInformationMissing: "Thông tin người dùng bị thiếu", // translated 
  failedToUpdatePushNotifications: "Không thể cập nhật cài đặt thông báo đẩy.", // translated 
  notificationPermissionDenied: "Bạn đã từ chối cấp quyền nhận thông báo. Vui lòng bật tính năng này trong cài đặt trình duyệt của bạn.", // translated 
  notificationPermissionRequired: "Bạn cần có quyền truy cập thông báo để bật thông báo đẩy.", // translated 
  notSupported: "Không được hỗ trợ", // translated 
  permissionDenied: "Quyền truy cập bị từ chối", // translated 
  permissionNotRequested: "Không yêu cầu sự cho phép", // translated 
  enabled: "Đã bật", // translated 
  disabled: "Tàn tật", // translated 
};


export default my_profile;
